import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import QRIcon from '../../assets/QR-icon.svg'
import { getTenantInfoByKey, replaceExpecialCharacters } from '../../helpers/helpers';
import { CustomAlert } from '../CustomAlert/CustomAlert';
import './inputs.css'
import { t } from 'i18next';
import AccessContext from '../../context/AccessContext/AccessContext';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
const AccessInput = ({ canScan = getTenantInfoByKey('qr_enabled') }) => {

    const { clean } = useContext(AccessContext);
    const { cleanAccessVehiclesState } = useContext(AccessVehiclesContext);

    const [id, setId] = useState('');

    const [minError, setMinError] = useState(false);

    const navigate = useNavigate();

    const minLength = id.length >= 8;

    const handleAccessManual = (e) => {
        if (e.key === 'Enter' && !minLength) {
            setMinError(true)
            return
        }
        if (e.key === 'Enter' && minLength) {
            clean();
            cleanAccessVehiclesState();
            navigate(`/createAccess/${id}`)
            setMinError(false)
            return
        }
    }

    const handleChange = (e) => {
        const sanitizedValue = replaceExpecialCharacters(e.target.value);
        setId(sanitizedValue);
    };

    return (
        <div>
            <div className='position-relative mb-4'>
                <input
                    placeholder={t('SEARCH_CODE_OR_SCAN')}
                    type={"text"}
                    name={'searchAccess'}
                    className="form-control access-input"
                    autoComplete='off'
                    onChange={handleChange}
                    onKeyPress={handleAccessManual}
                    value={id}
                    maxLength={15}
                />
                {
                    canScan ?
                        <span
                            style={{ top: '15%', right: '10px', position: 'absolute' }}
                            type='button'
                            onClick={() => navigate('/QRScanAccess')}
                        >
                            <img src={QRIcon} alt="" />
                        </span>
                        :
                        null
                }
            </div>
            {minError ? <CustomAlert color={'danger'} text={t('MAX_EIGHT_CARACT_ALLOW')} /> : null}
        </div>

    )
}

export default AccessInput